const debug = false;
const wsProtocol = "wss";
const wsDomain = "socket.757sunztdw.com";
const wsPort = "11216";
const cpDomain = "cashier-pay.757sunztdw.com";
const title = "SundayPay";
const firstName = "Sunday";
const lastName = "Pay";
const providerDisplayMerchantOrder = false;
const providerAgentDisplayMerchantOrder = false;
const merchantDisplayProviderOrder = false;
const merchantAgentDisplayProviderOrder = false;
const agentDisplayCreateButton = false;
const merchantCanCancelWithdrawalOrder = false;
const cashierModel = "CashierEN";
const icon = "S";
const gcashTitle = "SundayPay, Inc.";
const formCtrlBtn = "Y";
const orderSTimeBaseDay = 0;
const limitQryDate = "Y";
const showQrCode = "Y";
const utcOffset = "+08:00";

export default {
    debug: debug,
    wsProtocol: wsProtocol,
    wsDomain: wsDomain,
    wsPort: wsPort,
    cpDomain: cpDomain,
    title: title,
    firstName: firstName,
    lastName: lastName,
    providerDisplayMerchantOrder: providerDisplayMerchantOrder,
    providerAgentDisplayMerchantOrder: providerAgentDisplayMerchantOrder,
    merchantDisplayProviderOrder: merchantDisplayProviderOrder,
    merchantAgentDisplayProviderOrder: merchantAgentDisplayProviderOrder,
    agentDisplayCreateButton: agentDisplayCreateButton,
    merchantCanCancelWithdrawalOrder: merchantCanCancelWithdrawalOrder,
    cashierModel: cashierModel,
    icon: icon,
    gcashTitle: gcashTitle,
    formCtrlBtn: formCtrlBtn,
    orderSTimeBaseDay: orderSTimeBaseDay,
    limitQryDate: limitQryDate,
    showQrCode: showQrCode,
    utcOffset: utcOffset,
};
